import React, { useState } from "react"
import { Script } from "gatsby"
import GraciasTracking from "./tracking/gracias-2-tracking"
import Seo from "../../components/seo"

const HeadTag = ({ tracking, title, description, shareUrl, shareImage, imageAlt, keywords }) => {

  const [loaded, setLoaded] = useState(false)

  // Imagen predeterminada para compartir en redes sociales si no se proporciona una específica
  const defaultShareImage = '/images/social/claus-social-share.jpg'
  
  // Metadescripción predeterminada si no se proporciona una específica
  const defaultDescription = "Claus: Software de facturación electrónica y gestión contable que simplifica tus procesos fiscales. Optimiza tus procesos fiscales, emite facturas electronicas y administra tu contabilidad digital en la nube."
  
  // Palabras clave predeterminadas si no se proporcionan específicas
  const defaultKeywords = "facturación electrónica, factura electrónica, software contable, gestión fiscal, contabilidad digital, finanzas empresariales, impuestos"
  
  // Preparar los datos de SEO que pasaremos a nuestro componente Seo
  const seoData = {
    metaTitle: title,
    metaDescription: description || defaultDescription,
    // Usar imagen proporcionada o la predeterminada
    shareImage: (shareImage ? { localFile: { url: shareImage } } : { localFile: { url: defaultShareImage } }),
    // Si hay una URL para compartir, es un artículo
    article: shareUrl ? true : false,
    // Propiedades adicionales para mejorar el SEO y compartir en redes sociales
    imageAlt: imageAlt || 'Claus - Software de Facturación Electrónica',
    keywords: keywords || defaultKeywords
  }
  
  return (
    <>
      <Seo seo={seoData} />

      <meta
        name="facebook-domain-verification"
        content="jovcnpmeoio3knr2lii3q4rrluiout"
      />
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-5TYM9DPM2K"
        onLoad={() => setLoaded(true)}
      />
      {loaded && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || []; 
            function gtag(){
              dataLayer.push(arguments);
            } 
            gtag('js', new Date()); 
            gtag('config', 'G-5TYM9DPM2K');`,
          }}
          crossorigin="anonymous"
        />
      )}
      {tracking && <GraciasTracking />}
    </>
  )
}

export default HeadTag
